<template>
  <section class="main-content">
    <transition name="fade-transform">
      <router-view/>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain'
}
</script>

<style lang="scss" scoped>
.main-content {
  width: calc(1vw * 100);
}
</style>



// WEBPACK FOOTER //
// src/components/menu_components/AppMain.vue